<template>
  <div class="header">
    <div class="nav-icon" @click="show = true">
      <img src="../assets/nav-icon.png"/>
    </div>
    <nav :class="show ? 'active' : ''" @click="show = false">
      <div class="close">
        <div class="close-icon">
          <img src="../assets/nav-close.png"/>
        </div>
      </div>
      <div class="nav-content">
        <div
          class="nav-item"
          v-for="item in navList" :key="item.value"
          @click.stop="jump(item)"
        >
          {{ item.label }}
        </div>
      </div>
    </nav>
    <div :class="show ? 'bg-null active' : 'bg-null'"></div>
  </div>
</template>

<script>
export default {
  name: 'headerWap',
  data () {
    return {
      show: false,
      navList: [
        {label: '首页', path: '/', value: 0},
        {label: '东方创科', path: '', value: 1},
        {label: 'Kids+', path: '', value: 2},
        {label: '联系我们', path: '/contactUs', value: 3}
      ]
    }
  },
  methods: {
    jump (row) {
      this.$router.push(row.path)
      this.show = !this.show
    }
  }
}
</script>

<style scoped lang="scss">
.header{
  .nav-icon{
    position: fixed;
    z-index: 9999;
    top: 10px;
    right: 10px;
    width: 45px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #e5e5e5;
    img{
      width: 25px;
    }
  }
  .bg-null{
    position: fixed;
    z-index: 9999;
    height: 100vh;
    width: 100%;
    right: -100%;
    top: 0;
    background-color: #fff;
    &.active{
      transition: right 0.2s;
      right: 0;
    }
  }
  nav{
    position: fixed;
    z-index: 10000;
    height: 100vh;
    width: 100%;
    right: -100%;
    top: 0;
    background: rgba(30,115,190,0.69);
    //transition: right 0.2s;
    .close{
      display: flex;
      justify-content: flex-end;
      padding: 10px 10px 0 0;
      border-bottom: 1px solid #cccccc;
      .close-icon{
        width: 45px;
        height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #e5e5e5;
        img{
          width: 25px;
        }
      }
    }
    .nav-content{
      .nav-item{
        padding: 10px 0;
        font-size: 16px;
        color: #fff;
        background-color: #3b8ceb;
        border-bottom: 1px solid #cccccc;
      }
    }
    &.active{
      transition: right 0.2s;
      right: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headerWap.vue